module.exports = __webpack_public_path__ + "static/img/shopify.9997041c.png";